import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { webviewHttpClient } from '@/app/[locale]/(order)/components/auth/webview-http-client';

export interface AddAddressRequest {
  address: string;
  place_id: string;
  lat: number;
  lng: number;
}

export interface AddAddressResponse {}

export const addAddressFn = async (
  requestData: AddAddressRequest,
  token?: string
): Promise<AddAddressResponse> => {
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await webviewHttpClient.post<AddAddressResponse>(
    apiRoutes.ahafood.store.add_new_address,
    requestData,
    {
      headers,
    }
  );

  return response?.data;
};

export const useAddAddress = (
  token?: string,
  opts?: UseMutationOptions<
    AddAddressResponse,
    DefaultQueryError,
    AddAddressRequest
  >
) =>
  useMutation<AddAddressResponse, DefaultQueryError, AddAddressRequest>({
    mutationFn: (requestData) => addAddressFn(requestData, token),
    ...opts,
  });
